import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { AccessRequired } from 'src/components/AccessRequired'
import { NotFound } from 'src/components/NotFound'

import { AdminLayout } from './layout'
import { MaskPage, UnmaskPage, ManageDevicesPage } from './pages'

export const AdminRouter = () => {
  return (
    <AdminLayout>
      <Switch>
        <Route path='/admin/mask' exact>
          <AccessRequired staff logout={false}>
            <MaskPage />
          </AccessRequired>
        </Route>
        <Route path='/admin/unmask' component={UnmaskPage} exact>
          <AccessRequired masked logout={false}>
            <UnmaskPage />
          </AccessRequired>
        </Route>
        <Route path='/admin/devices' component={ManageDevicesPage} exact>
          <AccessRequired staff logout={false}>
            <ManageDevicesPage />
          </AccessRequired>
        </Route>
        <Route path='*'>
          <NotFound />
        </Route>
      </Switch>
    </AdminLayout>
  )
}
